<template>
  <div class="page-container">
    <div class="content-container">
      <div class="privacy-policy-content" v-html="processedHtml"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue';

const rawHtml = ref('');

const processedHtml = computed(() => {
  if (!rawHtml.value) return '';
  
  // 创建一个临时的 DOM 解析器
  const parser = new DOMParser();
  const doc = parser.parseFromString(rawHtml.value, 'text/html');
  
  // 提取 body 中的内容
  const content = doc.body.innerHTML;
  
  return content;
});

onMounted(async () => {
  try {
    const response = await fetch('/privacy_policy.html');
    rawHtml.value = await response.text();
  } catch (error) {
    console.error('Failed to load privacy policy:', error);
    rawHtml.value = '<p>Failed to load privacy policy.</p>';
  }
});
</script>

<style scoped>
.page-container {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
}

.content-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
}

.privacy-policy-content {
  background: #fff;
  border-radius: 8px;
}

.privacy-policy-content :deep(*) {
  max-width: 100%;
  box-sizing: border-box;
}

/* Reset styles for loaded content */
.privacy-policy-content :deep(body),
.privacy-policy-content :deep(html) {
  all: unset;
  display: block;
}

/* Preserve text styles */
.privacy-policy-content :deep(h1),
.privacy-policy-content :deep(h2),
.privacy-policy-content :deep(h3),
.privacy-policy-content :deep(h4),
.privacy-policy-content :deep(h5),
.privacy-policy-content :deep(h6) {
  color: #333;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  font-weight: bold;
}

.privacy-policy-content :deep(h1) { font-size: 2em; }
.privacy-policy-content :deep(h2) { font-size: 1.5em; }
.privacy-policy-content :deep(h3) { font-size: 1.17em; }
.privacy-policy-content :deep(h4) { font-size: 1em; }
.privacy-policy-content :deep(h5) { font-size: 0.83em; }
.privacy-policy-content :deep(h6) { font-size: 0.67em; }

.privacy-policy-content :deep(p) {
  color: #666;
  line-height: 1.6;
  margin: 1em 0;
}

/* 确保内容区域的样式不会被覆盖 */
.privacy-policy-content {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
}
</style> 